export default {
  title: 'Arrematantes',
  menu: [
    {
      id: 'arrematantes',
      title: 'Arrematantes',
      icon: 'clipboard-list-check',
      style: 'light',
      url: '/#/arrematantes/lista'
    },
    {
      id: 'relatorios',
      title: 'Relatórios',
      icon: 'user-chart',
      style: 'regular',
      url: '#'
    },
    {
      id: 'cadastros',
      title: 'Cadastros básicos',
      icon: 'cog',
      style: 'light',
      url: '/#/cadastro'
    }
  ]
}
